module.exports = __webpack_public_path__ + "img/img-5.5c2c7e79.png";